<template>
  <div>
    <div class="custom-card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="my-3">
                <image-uploader :imageUrl="''" @input="uploadImage($event)" @remove-image="removeImage"
                  :isUploadingImage="isUploadingImage" />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">First Name</label>
                <input type="text" class="input" v-model="user.firstname" placeholder="-- Enter First Name --" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Middle Name</label>
                <input type="text" class="input" v-model="user.middlename" placeholder="-- Enter Middle Name --" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="lname" class="label">Last Name</label>
                <input type="text" class="input" v-model="user.lastname" placeholder="-- Enter Last Name --" />
              </div>
            </div>
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">Gender</label>
                <el-select v-model="user.gender" placeholder="-- Select --">
                  <el-option v-for="gender in genders" :key="gender" :label="gender" :value="gender">
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Email Address</label>
                <input type="email" disabled class="input" v-model="user.email" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Phone Number</label>
                <vue-tel-input :preferredCountries="['Nigeria']" v-model="user.mobile_no"></vue-tel-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <h3>Contact Address</h3>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fname" class="label">Address</label>
              <!-- <div class="d-flex modal-input">
                <input type="text" class="input" v-model="newUser.mname" />
                <span @click="showPasswordModal = true"><img src="@/assets/images/icons/edit.svg" alt=""></span>
              </div> -->
              <vue-google-autocomplete id="map2" ref="shipperAddress" :value="location.address" classname="input"
                placeholder="Enter address" v-on:placechanged="getAddress">
              </vue-google-autocomplete>
            </div>
          </div>

          <div hidden class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fname" class="label">Security Question</label>
              <div class="d-flex modal-input">
                <input type="text" class="input" v-model="newUser.mname" />
                <span @click="showSecurityQuestionModal = true"><img src="@/assets/images/icons/edit.svg" alt=""></span>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="mname" class="label">Country</label>
              <input type="text" class="input" v-model="location.country" />
              <!-- <div class="d-flex modal-input">
                <input type="text" class="input" v-model="newUser.mname" />
                <span @click="showTwoFactorModal = true"><img src="@/assets/images/icons/edit.svg" alt=""></span>
              </div> -->
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="gender" class="label">State</label>
              <input type="text" class="input" v-model="location.state" />
            </div>
          </div>

          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="lname" class="label">City</label>
              <input type="text" class="input" v-model="location.city" />
            </div>
          </div>

        </div>

        <div class="flex items-center my-4 justify-between">
          <div class="cursor-pointer" @click="$router.go(-1)">
            <p>Cancel</p>
          </div>
          <primary-button buttonText="Save" @click="updateUser" :loading="updatingUser" />
        </div>
      </div>
    </div>

    <update-password-modal :show-modal="showPasswordModal" @close-modal="showPasswordModal = false" />
    <password-policy-modal :show-modal="showPolicyModal" @close-modal="showPolicyModal = false" />
    <security-question-modal :show-modal="showSecurityQuestionModal" @close-modal="showSecurityQuestionModal = false" />
    <two-factor-modal :show-modal="showTwoFactorModal" @close-modal="showTwoFactorModal = false" />

  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import ImageUploader from "@/components/3pl/Users/ImageUploader";

import UpdatePasswordModal from "@/views/3pl/Settings/SecurityPolicy/Modals/UpdatePassordModal";
import SecurityQuestionModal from "@/views/3pl/Settings/SecurityPolicy/Modals/SecurityQuestionModal";
import TwoFactorModal from "@/views/3pl/Settings/SecurityPolicy/Modals/TwoFactorModal";
import PasswordPolicyModal from "@/views/3pl/Settings/SecurityPolicy/Modals/PasswordPolicyModal";

import timezones from "@/utilities/timezones";
export default {
  components: {
    ImageUploader,
    TwoFactorModal,
    SecurityQuestionModal,
    UpdatePasswordModal,
    PasswordPolicyModal,
    VueGoogleAutocomplete
  },
  data() {
    return {
      location: {
        address: "",
        country: "",
        state: "",
        city: "",
      },

      states: [],
      countries: ["Nigeria"],
      cities: [],

      showPolicyModal: false,
      showSecurityQuestionModal: false,
      showPasswordModal: false,
      showTwoFactorModal: false,
      timezones: timezones,
      newUser: {
        fname: "",
        mname: "",
        lname: "",
        gender: "",
        email: "",
        phoneNo: "",
        employmentType: "",
      },
      user: {
        firstname: "oba",
        middlename: "three",
        lastname: "pl",
        gender: "male",
        email: "thevetdoctor@gmail.com",
        hash: "5fd56c1fee8f10c161f9f14b536895062008f50b6b4d0ad45164cb80aca7ae8bc37e375d9c7ed1dd5deb8b6e400ed790b44fd6432089386e97730e3fce4d910d",
        salt: "6e930199a117a78a1090c8ac1510c110e9972e4c3e24f45568472f4309201c42",
        accounttype: "organization",
        image: null,
        imageurl: "https://cloudenly-primary.s3.eu-west-2.amazonaws.com/muleex/1630526780862-1626247746317.jpg",
        onboardingtype: "3PL",
        mobile_no: "08069100466",
        twoFA: null,
        securityques: null,
        answer: null,
        createdAt: "2021-08-24T19:31:07.409Z",
        updatedAt: "2021-10-13T10:15:59.754Z",
        passwordauth: null,
        Orgs: [
          {
            id: "a62faded-e513-41b9-b2f7-5f1c21d49bf8",
            userId: "7dea03b7-c2d6-4540-89b9-40119db6d81f",
            companyname: "updated organization name",
            customdomain: "obang",
            industry: "Agriculture",
            regnumber: "oba01",
            mobile_no: "0806 910 0463",
            email: "thevetdoctor@gmail.com",
            image: null,
            imageurl: "",
            specialization: "Agro-Allied Services",
            address: "updated organization address",
            city: null,
            country: null,
            type: null,
            stateId: null,
            twoFA: null,
            web: null,
            facebook: null,
            linkedin: null,
            twitter: null,
            instagram: null,
            createdAt: "2021-08-24T19:33:22.072Z",
            updatedAt: "2021-10-06T23:58:12.243Z"
          }
        ]
      },
      genders: ["Male", "Female"],
      languages: ["English"],
      employmentTypes: [
        "Full-time",
        "Part-time",
        "Intern",
        "Company-paid Temporary",
        "Independent Contractor",
        "Agency-paid Temporary",
        "Vendor Employee",
        "Volunteer",
      ],
      creatingUser: false,
      roles: [],
      selectedRoleId: '',
      isUploadingImage: false,
      updatingUser: false
    };
  },

  watch: {
    "location.state"(val) {
      this.cities = [];
      if (val?.length > 0) {
        this.cities = [
          ...this.states.find((state) => state.name == val).cities,
        ];

       
      }
    },
    location: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.long) {
          this.geoCoderPayload.long = val.long;
        }
        if (val.lat) {
          this.geoCoderPayload.lat = val.lat;
        }
        if (this.geoCoderPayload.lat && this.geoCoderPayload.long) {
          this.getGeoCoder();
        }
      },
    },
  },

  computed: {
    disableButton() {
      return this.shouldDisableButton(this.newUser);
    },
    geoCoderPayload() {
      return {
        lat: null,
        long: null,
      };
    }
  },

  
  mounted() {
    this.getAllStates();

    this.user = JSON.parse(localStorage.getItem("loggedInUser"));
    
    if (!this.user) {
      this.$router.push("/login");
    }
  },
  methods: {
    async getGeoCoder() {
      try {
        const response = await this.$_getStateNameWithDim(this.geoCoderPayload);
        
        let geoData = response.data;
        this.location.state = geoData.state;
        this.location.city = geoData.address.city;
        this.location.country = geoData.address.country;
      } catch (error) {
        this.handleError();
      }
    },
    
    async getAllStates() {
      try {
        let response = await this.$_getAllStatesAndCities();
        this.states = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    getAddress(addressData) {
      this.location.address = addressData.route;
      this.location.lat = addressData.latitude;
      this.location.long = addressData.longitude;
    },


    async updateUser() {
      this.updatingUser = true;
  
      let payload = {
          user: {
              firstname: this.user.firstname,
              middlename: this.user.middlename,
              lastname: this.user.lastname,
              gender: this.user.gender,
              email: this.user.email,
              mobile_no: this.user.mobile_no
          },
      }

      try {
        let response = await this.$_saveAccountOwnerInformation(payload);
        this.$store.dispatch("saveUserDetails", response.data.data.user);
        this.generateToast("Your information has been updated!", "success");
        this.updatingUser = false;
        this.$router.push({ name: "AccountProfile" });
      } catch (error) {
        this.handleError(error);
        this.updatingUser = false;
      }
    },
    
    async uploadImage(image) {
   
      this.isUploadingImage = true;
      const formData = new FormData();
      formData.append("file", image);
      formData.append("upload_preset", "zunt8yrw");
      try {
        let response = await this.$_uploadImage(formData);
       
        this.user.imageurl = response.data.secure_url;
        this.generateToast("Image uploaded", "success");
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.user.imageurl = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.picture-upload-form {
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
} 
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.new-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}

.modal-input {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  height: 2.75rem;
  border-radius: 4px;
  display: flex;

  input {
    border: none;
    background: transparent;
  }
  span {
    align-self: center;
    padding-right: 0.5rem;
    color: #747474;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
